import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AuthenticationService } from '../../services/authentication.service';
import { AccountService } from 'src/app/accounts/account.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  selectedBusiness: any;
  subcontractorName: any;
  constructor(public authenticationService: AuthenticationService, private accountService: AccountService, private router: Router, public cookieService: CookieService) {
    this.selectedBusiness = sessionStorage.getItem('Business');
  }

  ngOnInit(): void {
    this.getUserDetail()
  }

  logout() {
    // this.authenticationService.logout();

    this.accountService.clearSession('').subscribe((sessionData:any) => {
      if (sessionData['authenticated'] == false) {
        this.authenticationService.logout();
      }
    }, error => {
      console.log(error);
    })


  }

  routeToChangePass() {
    this.router.navigate(['/change-password'])
  }

  routeTodashboard() {
    this.router.navigate(['/dashboard'])
  }

  routeToProfile() {
    this.router.navigate(['/profile'])
  }
  getUserDetail() {
    // 'userdata' has already been set; May skip request.
    if (sessionStorage.getItem('userdata')) {
      // let userData = JSON.parse(sessionStorage?.getItem('userdata'));
      const user_data = sessionStorage.getItem('userdata');
      const userData = user_data ? JSON.parse(user_data) : null;
      this.subcontractorName = userData.subcontractor_name;
      return;
    }

    this.accountService.getUserDetail().subscribe(data => {
      let userData = JSON.stringify(data)
      sessionStorage.setItem('userdata', userData);
      this.cookieService.set('subcontractorName', data.subcontractor_name);
      if (this.cookieService.check('subcontractorName')) {
        this.subcontractorName = this.cookieService.get('subcontractorName');
      }
    })
  }
}
